<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
// Overrides @basecom-gmbh/pond/components/ProductListing/ProductListingSorting.vue
import type { Schemas } from '@shopware/api-client/api-types';

const props = defineProps<{
    options: Schemas['ProductListingResult']['availableSortings'];
    selectedOption: Schemas['ProductListingResult']['sorting'];
}>();
const emit = defineEmits<{
    'sorting-changed': [key: Schemas['ProductListingResult']['sorting']];
}>();

const toggleState = ref(false);

const handleClick = (option: Schemas['ProductListingResult']['availableSortings'][0]) => {
    toggleState.value = false;
    emit('sorting-changed', option.key);
};
</script>

<template>
    <DropdownMenuRoot v-model:open="toggleState">
        
<FormKitLazyProvider config-file="true">
<DropdownMenuTrigger
            class="text-black flex flex-nowrap items-center justify-between text-nowrap rounded-full border px-4 py-2 text-md"
            :class="{
                '!border-accent-orange': toggleState,
            }"
            :aria-label="$t('listing.sidebar.sorting.ariaLabel')"
        >
            <span class="text-nowrap text-left">{{ $t('listing.sidebar.sorting.text') }}</span>
            <FormKitIcon
                icon="chevron-down"
                :class="{
                    'rotate-180': toggleState,
                }"
                class="ml-6 size-3 transition-all duration-150"
            />
        </DropdownMenuTrigger>
        <DropdownMenuPortal>
            <DropdownMenuContent
                class="bg-white z-10 min-w-56 rounded-md border border-gray p-4 shadow-md outline-none"
                :side-offset="5"
                align="end"
            >
                <DropdownMenuItem
                    v-for="option in props.options"
                    :key="option.key"
                    :value="option.key"
                    class="not: data-[highlighted]:text-black cursor-pointer outline-none data-[disabled]:pointer-events-none [&:not(:last-child)]:pb-3"
                    :class="{
                        'font-bold': option.key === props.selectedOption,
                    }"
                    @click="() => handleClick(option)"
                >
                    {{ option.label }}
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenuPortal>
</FormKitLazyProvider>

    </DropdownMenuRoot>
</template>
